/* eslint-disable import/prefer-default-export */
import dateFormatType from '@/constants/dateFormatType';
import { taxInvoiceStatus, taxInvoiceStatusChipMapper, } from '@/constants/taxInvoice/taxInvoiceStatus';
import { addCommaBetweenTextField, convertCase, numberToFormatted, validateTextWithHypen, } from '@/utils';
import { i18n } from '@/locales';
import { parse } from 'date-fns';
import { getFormattedDate } from '@/utils/time';
import { taxInvoiceNtsResultType } from '@/constants/taxInvoice/taxInvoiceNtsResultType';
import { objDeepCopy } from '@/utils/object';
export class HubAdjustmentTaxInvoice {
    _taxInvoice;
    constructor(data) {
        this._taxInvoice = data;
    }
    get status() {
        return this._taxInvoice.status;
    }
    /** 조회 성공 한 세금계산서의 발행 상태 */
    get statusChipData() {
        const chipData = taxInvoiceStatusChipMapper(this._taxInvoice.status);
        if (!chipData?.color) {
            return null;
        }
        return chipData;
    }
    /** 조회 성공 한 세금계산서의 발행 상태가 '실패'일 시 사유문구 */
    get statusFailedReason() {
        const { ntsResultType } = this._taxInvoice;
        if (!ntsResultType) {
            return '';
        }
        // 전송실패의 경우가 아니면 툴팁 미노출
        if (this._taxInvoice.status !== taxInvoiceStatus.TRANSFER_FAILED) {
            return '';
        }
        const noTooltipTypeList = [
            taxInvoiceNtsResultType.NONE,
            taxInvoiceNtsResultType.SUCCESS,
        ];
        // 성공, 없음의 경우엔 툴팁 미노출
        if (noTooltipTypeList.includes(ntsResultType)) {
            return '';
        }
        const lc = 'views.tax_invoice.nts_result_type_option.';
        const reasonText = i18n.t(`${lc}${convertCase(ntsResultType, 'enum', 'snake')}`);
        return reasonText;
    }
    /** 책번호(권) - 1차 설계 리스폰스에 필드 자체가 없음 */
    // eslint-disable-next-line
    get formattedBookNumber() {
        return validateTextWithHypen('');
    }
    /** 책번호(호) - 1차 설계 리스폰스에 필드 자체가 없음 */
    // eslint-disable-next-line
    get formattedBookIndex() {
        return validateTextWithHypen('');
    }
    /** 일련번호 - 1차 설계 리스폰스에 필드 자체가 없음 */
    // eslint-disable-next-line
    get formattedSerialNumber() {
        return validateTextWithHypen('');
    }
    // 공급자
    /** 등록번호 */
    get formattedInvoicerBusinessNumber() {
        return validateTextWithHypen(this._taxInvoice.invoicerBusinessInfo.businessNumber);
    }
    /** 종사업장(법인 본점에 종속된 사업장) - 1차 설계 리스폰스에 필드 자체가 없음 */
    // eslint-disable-next-line
    get formattedInvoicerSubBusinessName() {
        return validateTextWithHypen('');
    }
    /** 상호 */
    get formattedInvoicerBusinessName() {
        return validateTextWithHypen(this._taxInvoice.invoicerBusinessInfo.businessName);
    }
    /** 성명(대표자명) */
    get formattedInvoicerCeoName() {
        return validateTextWithHypen(this._taxInvoice.invoicerBusinessInfo.ceoName);
    }
    /** 사업장 주소 TODO */
    get formattedInvoicerAddress() {
        const { siDo, siGunGu, eupMyeonDong, ri, landNumber, roadName, buildingNumber, buildingName, detail, } = this._taxInvoice.invoicerBusinessInfo.address;
        const addressList = [
            siDo,
            siGunGu,
            eupMyeonDong,
            ri,
            landNumber,
            roadName,
            buildingNumber,
            buildingName,
            detail,
        ];
        return addCommaBetweenTextField(addressList, false);
    }
    get formattedInvoicerAddressNoDetail() {
        const { siDo, siGunGu, eupMyeonDong, ri, landNumber, roadName, buildingNumber, buildingName, } = this._taxInvoice.invoicerBusinessInfo.address;
        const addressList = [
            siDo,
            siGunGu,
            eupMyeonDong,
            ri,
            landNumber,
            roadName,
            buildingNumber,
            buildingName,
        ];
        return addCommaBetweenTextField(addressList, false);
    }
    get invoicerAddress() {
        return this._taxInvoice.invoicerBusinessInfo.address;
    }
    /** 업태 */
    get formattedInvoicerBusinessCondition() {
        return validateTextWithHypen(this._taxInvoice.invoicerBusinessInfo.businessCondition);
    }
    /** 종목 */
    get formattedInvoicerBusinessType() {
        return validateTextWithHypen(this._taxInvoice.invoicerBusinessInfo.businessType);
    }
    /** 공급자 담당자 */
    get formattedInvoicerContectInfo() {
        const info = objDeepCopy(this._taxInvoice.invoicerContactInfo);
        Object.entries(info).forEach(([key, value,]) => {
            // @ts-ignore
            info[key] = validateTextWithHypen(value);
        });
        return info;
    }
    // 공급받는 자
    /** 등록번호 */
    get formattedInvoiceeBusinessNumber() {
        return validateTextWithHypen(this._taxInvoice.invoiceeBusinessInfo.businessNumber);
    }
    /** 종사업장(법인 본점에 종속된 사업장) - 1차 설계 리스폰스에 없음 */
    // eslint-disable-next-line
    get formattedInvoiceeSubBusinessName() {
        return validateTextWithHypen('');
    }
    /** 상호 */
    get formattedInvoiceeBusinessName() {
        return validateTextWithHypen(this._taxInvoice.invoiceeBusinessInfo.businessName);
    }
    /** 성명(대표자명) */
    get formattedInvoiceeCeoName() {
        return validateTextWithHypen(this._taxInvoice.invoiceeBusinessInfo.ceoName);
    }
    /** 사업장 주소 TODO */
    get formattedInvoiceeAddress() {
        const { siDo, siGunGu, eupMyeonDong, ri, landNumber, roadName, buildingNumber, buildingName, detail, } = this._taxInvoice.invoiceeBusinessInfo.address;
        const addressList = [
            siDo,
            siGunGu,
            eupMyeonDong,
            ri,
            landNumber,
            roadName,
            buildingNumber,
            buildingName,
            detail,
        ];
        return addCommaBetweenTextField(addressList, false);
    }
    /** 업태 */
    get formattedInvoiceeBusinessCondition() {
        return validateTextWithHypen(this._taxInvoice.invoiceeBusinessInfo.businessCondition);
    }
    /** 종목 */
    get formattedInvoiceeBusinessType() {
        return validateTextWithHypen(this._taxInvoice.invoiceeBusinessInfo.businessType);
    }
    /** 공급받는자 담당자 */
    get formattedInvoiceeContectInfo() {
        const info = this._taxInvoice.invoiceeContactInfo;
        Object.entries(info).forEach(([key, value,]) => {
            // @ts-ignore
            info[key] = validateTextWithHypen(value);
        });
        return info;
    }
    /** 작성일자 */
    get formattedWriteDate() {
        const { writeDate } = this._taxInvoice;
        if (!writeDate) {
            return validateTextWithHypen(writeDate);
        }
        return getFormattedDate(writeDate, 'yyyyMMdd', dateFormatType.DATE);
    }
    /** 공급가액 */
    get formattedSupplyCost() {
        const { supplyCost } = this._taxInvoice;
        if (!supplyCost) {
            return validateTextWithHypen(supplyCost);
        }
        return numberToFormatted(supplyCost);
    }
    /** 세액 */
    get formattedTax() {
        const { tax } = this._taxInvoice;
        if (!tax) {
            return validateTextWithHypen(tax);
        }
        return numberToFormatted(tax);
    }
    /** 비고1 */
    get formattedMemo1() {
        return validateTextWithHypen(this._taxInvoice.memo1);
    }
    /** 비고2 */
    get formattedMemo2() {
        return validateTextWithHypen(this._taxInvoice.memo2);
    }
    /** 비고3 */
    get formattedMemo3() {
        return validateTextWithHypen(this._taxInvoice.memo3);
    }
    /** 품목 정보 */
    get taxInvoiceItemList() {
        const itemList = this._taxInvoice.taxInvoiceItems.map((item) => {
            const innerItem = item;
            // 내부 포멧팅
            Object.entries(item).forEach(([key, value,]) => {
                if (typeof value === 'string') {
                    // @ts-ignore
                    innerItem[key] = validateTextWithHypen(value);
                }
                if (typeof value === 'number') {
                    // @ts-ignore
                    innerItem[key] = numberToFormatted(value);
                }
            });
            const purchaseDate = parse(item.purchaseDate, 'yyyyMMdd', new Date());
            const month = purchaseDate.getMonth() + 1;
            const date = purchaseDate.getDate();
            return {
                ...innerItem,
                purchaseDate,
                month,
                date,
            };
        });
        return itemList;
    }
    /** 합계금액 */
    get formattedTotalCost() {
        const { totalCost } = this._taxInvoice;
        if (!totalCost) {
            return validateTextWithHypen(totalCost);
        }
        return numberToFormatted(totalCost);
    }
    /** 현금 - 1차 설계 리스폰스에 필드는 있으나 항상 null */
    get formattedCash() {
        const { cash } = this._taxInvoice;
        if (!cash) {
            return validateTextWithHypen(cash);
        }
        return numberToFormatted(cash);
    }
    /** 수표 - 1차 설계 리스폰스에 필드는 있으나 항상 null */
    get formattedCheckBill() {
        const { checkBill } = this._taxInvoice;
        if (!checkBill) {
            return validateTextWithHypen(checkBill);
        }
        return numberToFormatted(checkBill);
    }
    /** 어음 - 1차 설계 리스폰스에 필드는 있으나 항상 null */
    get formattedPromissoryNote() {
        const { promissoryNote } = this._taxInvoice;
        if (!promissoryNote) {
            return validateTextWithHypen(promissoryNote);
        }
        return numberToFormatted(promissoryNote);
    }
    /** 외상미수금 - 1차 설계 리스폰스에 필드는 있으나 항상 null */
    get formattedCredit() {
        const { credit } = this._taxInvoice;
        if (!credit) {
            return validateTextWithHypen(credit);
        }
        return numberToFormatted(credit);
    }
    /** 공급자 문서번호 */
    get formattedInvoicerDocumentId() {
        return validateTextWithHypen(this._taxInvoice.invoicerDocumentId);
    }
}
